import { extensionOf } from '@erp-attach/shared';

export type FileFamily = 'pdf' | 'image' | 'sheet' | 'doc' | 'other';

const FAMILY_BY_EXT: Record<string, FileFamily> = {
  pdf: 'pdf',
  jpg: 'image',
  jpeg: 'image',
  png: 'image',
  heic: 'image',
  tif: 'image',
  tiff: 'image',
  gif: 'image',
  webp: 'image',
  xlsx: 'sheet',
  xls: 'sheet',
  csv: 'sheet',
  docx: 'doc',
  doc: 'doc',
};

/** Family for the plate tint. Falls back to the MIME type when the name has no usable extension. */
export function fileFamily(filename: string | null | undefined, mime?: string | null): FileFamily {
  const ext = filename ? extensionOf(filename) : '';
  if (ext && FAMILY_BY_EXT[ext]) return FAMILY_BY_EXT[ext];
  const type = (mime ?? '').toLowerCase();
  if (type === 'application/pdf') return 'pdf';
  if (type.startsWith('image/')) return 'image';
  if (type.includes('spreadsheet')) return 'sheet';
  if (type.includes('wordprocessing')) return 'doc';
  return 'other';
}

/** Short label for the plate: "PDF", "JPG", "XLSX", or "FILE" when unknown. Never longer than 4 chars. */
export function fileLabel(filename: string | null | undefined, mime?: string | null): string {
  const ext = filename ? extensionOf(filename) : '';
  if (ext) return ext.slice(0, 4).toUpperCase();
  const family = fileFamily(filename, mime);
  return family === 'other' ? 'FILE' : family.toUpperCase().slice(0, 4);
}

/** "Credit application.pdf" → "Credit application". */
export function stripExtension(filename: string): string {
  const ext = extensionOf(filename);
  if (!ext) return filename;
  const idx = filename.toLowerCase().lastIndexOf(`.${ext}`);
  return idx > 0 ? filename.slice(0, idx) : filename;
}
